import { useLocation } from 'react-router-dom';
import qs from 'qs';

const useFilters = (filterSections) => {
  const location = useLocation();
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  const sectionKeys = Object.keys(filterSections);
  const filteredKeys = sectionKeys.filter(
    (key) =>
      Array.isArray(filterSections[key]) && filterSections[key].length > 0
  );
  let structuredData = {};

  filteredKeys.forEach((key) => {
    const data = filterSections[key];
    structuredData[key] = data.map((itemData) => ({
      ...itemData,
      isChecked: queryParams[key] === itemData.slug,
    }));
  });

  return { arrayFilters: structuredData };
};

export default useFilters;
